import { ListFieldTypeEnum, type ListFieldConfig } from '@ztechapps/common.hook'
import { NotificationChannelEnum, NotificationPriorityEnum, NotificationTypeEnum } from '@ztechapps/common.contract'

export const notificationListFieldConfig: ListFieldConfig = {
  _id: { name: '_id', isVisible: false },
  title: { name: 'title', index: 0, size: 300 },
  createdAt: { name: 'createdAt', index: 1, type: ListFieldTypeEnum.dateTimeZone, size: 180, excludeOnSearch: true },
  priority: {
    name: 'priority',
    index: 2,
    type: ListFieldTypeEnum.select,
    fieldSettings: { listValues: Object.values(NotificationPriorityEnum) },
  },
  channel: {
    name: 'channel',
    index: 3,
    type: ListFieldTypeEnum.select,
    fieldSettings: { listValues: Object.values(NotificationChannelEnum) },
  },
  bodyPlain: { name: 'bodyPlain', index: 4, displayName: 'Message', size: 500 },
  isRead: { name: 'isRead', index: 5, isVisible: false, type: ListFieldTypeEnum.boolean, excludeOnSearch: true },
  type: {
    name: 'type',
    type: ListFieldTypeEnum.select,
    fieldSettings: { listValues: Object.values(NotificationTypeEnum) },
    isVisible: false,
  },
}
